import React from "react";
import PropTypes from "prop-types";
//Material imports
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import makeStyles from "@mui/styles/makeStyles";
import ResponsiveImage from "../responsive-image/ResponsiveImage";
//limitless imports
import { limitlessImage } from "@limitless/images";
import { generalSubHeaderStyles } from "../example-questions/ExampleQuestions";
import OldSignUpWelcome from "./OldSignUpWelcome";
const useStyles = makeStyles(theme => ({
  ...generalSubHeaderStyles(theme),
  container: {
    paddingTop: 32,
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column-reverse",
    textAlign: "center"
  },
  imageContainer: {
    height: "100%",
    width: "100%"
  },
  imageContent: {
    width: "100%",
    height: "100%",
    borderRadius: 16,
    maxHeight: 504
  },
  textContent: {
    paddingRight: 0,
    paddingTop: 24,
    wordWrap: "break-word",
    overflow: "hidden"
  },
  [theme.breakpoints.up("sm")]: {
    container: {
      flexDirection: "row",
      textAlign: "left"
    },
    textContent: {
      paddingRight: 35,
      paddingTop: 0
    }
  },
  [theme.breakpoints.up("md")]: {
    container: {
      paddingTop: 65
    }
  },
  [theme.breakpoints.up("lg")]: {
    container: {
      paddingTop: 115
    }
  }
}));
const SignUpWelcome = ({
  content,
  leftSpaceContainer,
  useAltDesign
}) => {
  const classes = useStyles();
  return /*#__PURE__*/React.createElement(React.Fragment, null, useAltDesign ? /*#__PURE__*/React.createElement(OldSignUpWelcome, {
    content: content
  }) : /*#__PURE__*/React.createElement(Grid, {
    container: true,
    className: `${classes.container} ${leftSpaceContainer}`
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 11,
    sm: 7,
    lg: 6,
    className: `${classes.textContent} ${classes.generalSubHeaderContent}`
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    color: "textPrimary",
    gutterBottom: true
  }, content.header), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    color: "textPrimary"
  }, content.subHeader)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    className: classes.imageContainer,
    xs: 9,
    sm: 5,
    lg: 6
  }, /*#__PURE__*/React.createElement(ResponsiveImage, {
    images: content.images,
    imageAlt: "sign-up-welcome",
    imageStyles: classes.imageContent,
    noImageSrc: limitlessImage
  }))));
};
SignUpWelcome.propTypes = {
  content: PropTypes.object.isRequired,
  leftSpaceContainer: PropTypes.string,
  useAltDesign: PropTypes.bool
};
export default SignUpWelcome;